import { Box, Flex, Heading, Image, Text } from "@chakra-ui/react";

const HelpCard = ({ image, title, text }) => {
  return (
    <Flex
      flexDir="column"
      alignItems="center"
      gap={5}
      p={[6, 8]}
      flex={1}
      bg="white"
      borderRadius="1.25rem"
      boxShadow="0 2px 12px rgba(0,0,0,0.07)"
      border="1px solid"
      borderColor="green.100"
      _hover={{ boxShadow: "0 8px 32px rgba(0,0,0,0.12)", transform: "translateY(-4px)" }}
      transition="all 0.25s"
    >
      <Box
        w="110px"
        h="110px"
        borderRadius="50%"
        overflow="hidden"
        bg="green.50"
        border="3px solid"
        borderColor="green.200"
        flexShrink={0}
      >
        <Image src={image} w="100%" h="100%" objectFit="cover" />
      </Box>
      <Heading size="md" color="green.700" textAlign="center">
        {title}
      </Heading>
      <Text fontSize="1rem" color="gray.600" textAlign="center" lineHeight={1.7}>
        {text}
      </Text>
    </Flex>
  );
};

export default HelpCard;
